import React, { useState, useMemo, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import A_EnhancedTable from "../../../../../Atoms/DataDisplay/DataGrid/A_EnhancedTable";
import ManageFieldsForm from "../ManageFields/ManageFieldsForm";
import { COLUMN_CONFIG, DEFAULT_ROW } from "../ManageFields/FieldDataTypes";

const useStyles = makeStyles(() => ({
    root: {
        width: "100%",
    },
}));

const FieldsDisplay = (props) => {
    const { currentPage, showSaveButton } = props;
    const classes = useStyles();
    const [isEditable, setIsEditable] = useState(false);
    const [currentRow, setCurrentRow] = useState(DEFAULT_ROW);
    const data = currentPage.fields;

    const columnConfiguration = useMemo(
        () => ({
            title: currentPage.name
                ? `Available fields for ${currentPage.name}`
                : "",
            noDataText: "No data available.",
            paginate: true,
            searchable: true,
            sortable: false,
            striped: true,
            addButton: true,
            isMaxHeight: true,
            action: {
                edit: true,
                delete: false,
            },
            columnConfig: COLUMN_CONFIG,
        }),
        [currentPage.name]
    );

    const handleAdd = useCallback(() => {
        setIsEditable(true);
        setCurrentRow(DEFAULT_ROW);
        showSaveButton(false);
    }, [showSaveButton]);

    const handleEdit = useCallback(
        (e) => {
            setIsEditable(true);
            const selectedRow = data.find(
                (item) => item.id === e.currentTarget.id
            );
            if (selectedRow) {
                setCurrentRow(selectedRow);
            }
            showSaveButton(false);
        },
        [data, showSaveButton]
    );

    const handleOnSave = useCallback(() => {
        setIsEditable(false);
        showSaveButton(true);
    }, [showSaveButton]);

    return (
        <>
            {!isEditable ? (
                <A_EnhancedTable
                    id="Fields-table"
                    className={classes.root}
                    data={data}
                    configurations={columnConfiguration}
                    handleAddButtonClick={handleAdd}
                    handleEditButtonClick={handleEdit}
                    // handleDeleteButtonClick={handleDelete}
                />
            ) : (
                <ManageFieldsForm
                    {...props}
                    data={currentRow}
                    onSave={handleOnSave}
                    currentPage={props.currentPage}
                />
            )}
        </>
    );
};

export default FieldsDisplay;
